
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop, Watch } from "vue-property-decorator";
    import { RadioChoiceOptions } from "@/model/pagePartOptions/RadioChoiceOptions";
    import { VisitAnswer } from "@/model/VisitAnswer";
    import { QuestionTextLayout } from "@/model/Enums";

    @Component({})
    export default class RadioChoicesPart extends Vue {

        mounted(): void {
            //console.log("+++ RadioChoicesPart options=", this.options);
            //console.log("+++ RadioChoicesPart answer=", this.answer);
            
            let i = 0;
            for(const choice of this.options.choices) {
                if(choice === this.answer?.givenAnswer) {
                    this.selectedChoiceIndex = i;
                    break;
                }
                i++;
            }
            //console.log("+++ RadioChoicesPart index=", this.selectedChoiceIndex);
        }

        selectedChoiceIndex: number = -1;

        @Prop({ default: new RadioChoiceOptions() })
        options!: RadioChoiceOptions;

        @Prop({ default: null })
        answer!: VisitAnswer|null;
        
        @Prop({ default: false })
        isAdminView!: boolean;

        // so we can use in template
        //questionTextLayout: any = QuestionTextLayout;

        get correctChoiceText(): string {
            if(!this.isAdminView || this.options.correctIndex < 0 || this.options.correctIndex >= this.options.choices.length) return "";
            return this.options.choices[this.options.correctIndex];
        }

        get isQuestionAbove(): boolean {
            return this.options.layoutType === QuestionTextLayout.QuestionAbove
            || this.options.layoutType === QuestionTextLayout.Default;
        }

        get isQuestionleft(): boolean {
            return this.options.layoutType === QuestionTextLayout.QuestionOnLeft;
        }

        @Watch("selectedChoiceIndex")
        private async onAnswerchanged(): Promise<void> {
            const text = this.options.choices[this.selectedChoiceIndex];
            this.$emit("answer-changed", this.selectedChoiceIndex, this.answer?.pagePartID ?? 0, text);
        }
    }
